import API from "../..";
import { fullUrl } from "../../utile/utile.api";

/* トークンチェック（未使用かつ有効期限内かを確認する。認証不要） */

export type VerifyTokenRequestParam = {
  /** ○	トークン */
  token: string,
}

const path = '/verify-token';

const verifyToken = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    post: (param: VerifyTokenRequestParam) => API.con
      .post<VerifyTokenRequestParam, {}>({ url: full, data: param }),
  })
}

export default verifyToken;
